module.exports = __webpack_public_path__ + "img/3GOLDAPPLE.3dab0101.png";